/*
 * Copyright (c) Dito Technologies
 */

import React, {Dispatch} from "react";
import UseSheetMusicFile from "ui/feature/root/upload/UseSheetMusicFile";
import styles from "./UploadWorkspaceFile.module.scss";
import UploadWorkspaceFileDeleteButton from "ui/feature/root/upload/UploadWorkspaceFileDeleteButton";
import {Action, State} from "ui/feature/root/FormReducer";
import UploadWorkspaceFileUploadStatusOverlay from "ui/feature/root/upload/UploadWorkspaceFileUploadStatusOverlay";

interface Props {
    state: State;
    file: File;
    dispatch: Dispatch<Action>
}

const UploadWorkspaceFile: React.FC<Props> = ({file, dispatch, state}) => {
    const dataUrl = UseSheetMusicFile(file);
    return (
        <div className={styles.sheetMusicImageContainer}>
            <UploadWorkspaceFileUploadStatusOverlay file={file} state={state} className={styles.statusOverlay}/>
            {dataUrl && <img alt={file.name} className={styles.sheetMusicImage} src={dataUrl}/>}
            <UploadWorkspaceFileDeleteButton dispatch={dispatch} file={file} className={styles.sheetMusicDeleteButton}/>
        </div>
    );
}

export default UploadWorkspaceFile;
